import { useNavigate } from "react-router-dom";
import ArticleForm from "components/articles/ArticleForm";
import { useArticles } from "components/articles/hooks/useArticles";
import Alert from "components/common/Alert";
import { useState } from "react";

export default function CreateArticle() {
  const navigate = useNavigate();
  const { addArticle } = useArticles();
  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";
  const companyId = localStorage.getItem("company_id");

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <ArticleForm
        onSubmit={async (fd) => {
          try {
            fd.append("company_id", companyId);
            fd.append("created_by", userId);

            await addArticle(fd);
            navigate("/admin/articles");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Failed to create article",
            });
          }
        }}
        onBack={() => navigate("/admin/articles")}
      />
    </>
  );
}
